import React, { FC } from 'react';
import { TextAreaProps as AntdTextAreaProps } from 'antd/lib/input';
import { ConfigProvider, Input } from 'antd';

const AntdTextArea = Input.TextArea

interface TextAreaProps extends AntdTextAreaProps {
    label?: string;
    wrapperClassName?: string;
}

export const TextArea: FC<TextAreaProps> = ({ label, wrapperClassName, ...props }) => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#205BFC',
                    colorPrimaryText: '#FFFFFF',
                    colorBorder: '#A6BDFE',
                    paddingContentVertical: 0,
                },
            }}
        >
            <div className={`flex flex-col w-full ${wrapperClassName ? wrapperClassName : ''}`}>
                {label && <label className="font-bold text-base text-black-100 mb-2 max-lg:text-sm">{label}</label>}
                <AntdTextArea
                    {...props}
                    className={
                        `border border-primary-40 rounded-lg min-h-36 text-base p-4 disabled:bg-white disabled:text-black-80 max-lg:text-sm ${props.className ? props.className : ''}`
                    }
                />
            </div>
        </ConfigProvider>
    );
};